import React from 'react';

import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';

import get from 'lodash/get';

import { namespace, actions, selectors } from '../';

import SelectField from '../../shared/form-elements/select/field';
import InputField from '../../shared/form-elements/input';
import Calendar from '../../shared/calendar/main';

import { isRequired, isSelected } from '../../shared/form/validation';

import withIntl from '../../shared/intl-hoc';

function Form({ intl, calendar, ...props }) {
	return (
		<form
			className='priorities-page-form'
			onSubmit={props.handleSubmit}
		>
			<div className='priorities-page-form-fields'>
				<div className='priorities-page-form-row'>
					<div className='priorities-page-form-field'>
						<Field
							name='product'
							placeholder={intl('Product')}
							component={SelectField}
							validate={[isSelected]}
							searchable
							showLabel={false}
							multi={false}
							options={props.productsLookups}
						/>
					</div>
					<div className='priorities-page-form-field'>
						<Field
							name='countries'
							placeholder={intl('Countries')}
							component={SelectField}
							searchable
							showLabel={false}
							multi
							options={props.locationsLookups}
						/>
					</div>
					<div className='priorities-page-form-field'>
						<Field
							name='cap'
							placeholder={intl('Cap')}
							component={InputField}
							validate={[isRequired]}
							showLabel={false}
						/>
					</div>
				</div>
			</div>

			<div>
				<Calendar
					isMaxDateDisabled
					intl={intl}
					{...calendar}
					onInit={calendar.formCalendarInit}
					onToggle={calendar.formCalendarToggle}
					onChange={calendar.formCalendarChange}
					onApply={calendar.formCalendarApply}
				/>

				<div className='priorities-page-form-buttons'>
					<button className='ui-btn ui-btn-primary'>
						{intl('Save')} {props.id}
					</button>
					<button
						className='ui-btn ui-btn-secondary ui-icon-clear'
						type='button'
						onClick={() => {}}
					/>
				</div>
			</div>
		</form>
	);
}

function mapStateToProps(state) {
	const values = selectors.getInitialValues(state);

	return {
		destroyOnUnmount: selectors.select(state, 'destroyOnUnmount'),

		initialValues: values,
		id: get(values, 'id'),

		calendar: selectors.getFormCalendar(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		calendar: bindActionCreators(actions.formCalendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(withIntl(Form));

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/product-cap/form/main.js